import { createIntlTranslations } from 'Features/Intl/fns';
import { Navbar } from 'Features/Shared/Components/Navbar';
import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { useRouter } from 'next/router';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { SRPFiltersBar } from '../Features/SRP/Components/SRPFiltersBar';
import { SRPList } from '../Features/SRP/Components/SRPList';
import { SRPMap } from '../Features/SRP/Components/SRPMap';
import { createStateFromQs, useQueryFilters } from '../Features/SRP/Hooks/useQueryFilters';

export default function Page({ filters }: { filters: any }) {
  const { t } = useTranslation('search');
  const router = useRouter();
  const [state, dispatch] = useQueryFilters(createStateFromQs(filters));

  // @hint: Check eslint rules, this will cause problems
  React.useEffect(() => {
    router.replace(
      {
        pathname: router.pathname,
        query: {
          ...state,
        },
      },
      undefined,
      { shallow: true },
    );
    // .then(() => console.log('Replacing...'));
  }, [state]);

  return (
    <div>
      <Head>
        <title>
          {t('meta.title')} {filters?.mt || ''} | Kaaja
        </title>
        <meta name="description" content={t('meta.description')} />
      </Head>
      <div className="sticky top-0 z-10 bg-white">
        <Navbar />
      </div>
      <main className="flex h-full">
        <SRPMap state={state} dispatch={dispatch} />
        <div className="w-full">
          <SRPFiltersBar state={state} dispatch={dispatch} />
          <SRPList state={state} dispatch={dispatch} />
        </div>
      </main>
    </div>
  );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const namespaces = ['navbar', 'footer', 'common', 'search', 'auctions'];
  const i18n = await serverSideTranslations(context.locale || 'en', namespaces);
  const locale = context.locale?.startsWith('it') ? 'it' : 'en';
  const intl = await createIntlTranslations(locale);

  return {
    props: {
      ...i18n,
      ...intl,
      filters: context.query,
    },
  };
}
